import { useEffect, useState } from "react";
import { fetchOpenData, type OpenDataStatus } from "./openData";

// Step conversion rate and SWEAT price move slowly; polling every 1.5s just
// hammered /api/open-data (and the wallet API behind it) for no visible gain.
const INTERVAL = 10_000;
const DEFAULT_OPEN_DATA = { oneStepPrice: 0, sweatPrice: 0 };

const useOpenData = () => {
  const [openData, setOpenData] = useState({
    ...DEFAULT_OPEN_DATA,
    status: "loading" as OpenDataStatus,
  });

  useEffect(() => {
    let isMounted = true;

    const updateOpenData = () => {
      fetchOpenData().then((result) => {
        if (!isMounted) return;
        setOpenData((previous) =>
          result
            ? { ...result, status: "success" }
            : { ...previous, status: "error" }
        );
      });
    };

    updateOpenData();

    const intervalId = setInterval(updateOpenData, INTERVAL);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);

  return openData;
};

export default useOpenData;
